/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  });

  function initHeroEffect(slick, control) {
    var currentSlide = slick.find(".hero-slide");
    if(currentSlide.hasClass('hero-image')) {
      switch (control) {
        case "play":
          currentSlide.trigger('playAnimation');
          break;
        case "reset":
          currentSlide.trigger('resetAnimation');
          break;
      }
    } else if(currentSlide.hasClass('hero-video')) {
      var player = currentSlide.find("iframe").get(0);
      switch (control) {
        case "play":
          player.contentWindow.postMessage(JSON.stringify({
            "event": "command",
            "func": "mute"
          }), "*");
          player.contentWindow.postMessage(JSON.stringify({
            "event": "command",
            "func": "playVideo"
          }), "*");
          break;
        case "reset": //pause video on reset
          player.contentWindow.postMessage(JSON.stringify({
            "event": "command",
            "func": "pauseVideo"
          }), "*");
          break;
        }
    }
  }

  var heroSlider = jQuery('.hero');
  heroSlider.on("init", function(slick){
    slick = jQuery(slick.currentTarget);
    setTimeout(function() {  //slick take a while to create elements after init
      //play if first slide is video
      var firstSlide = slick.find("[data-slick-index='0']");
      initHeroEffect(firstSlide, "play");
    }, 1000);
  });
  heroSlider.on("beforeChange", function(event, slick) {
    slick = jQuery(slick.$slider);
    initHeroEffect(slick, "reset");
  });
  heroSlider.on("afterChange", function(event, slick) {
    slick = jQuery(slick.$slider);
    initHeroEffect(slick, "play");
  });
  // initialise slick
  heroSlider.slick({
    slideToShow: 1,
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: "<img src='/content/themes/DailyPress/assets/images/arrow-left-white.png' class='a-left control-c slick-prev' />",
    nextArrow: "<img src='/content/themes/DailyPress/assets/images/arrow-right-white.png' class='a-left control-c slick-next' />",
  });


  var imageSlider = jQuery('.image-slider');
  imageSlider.slick({
    slideToShow: 1,
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: "<img src='/content/themes/DailyPress/assets/images/arrow-left-white.png' class='a-left control-c slick-prev' />",
    nextArrow: "<img src='/content/themes/DailyPress/assets/images/arrow-right-white.png' class='a-left control-c slick-next' />",
  });

});

/********
 * Debounce function
 *
 * Returns a function, that, as long as it continues to be invoked, will not be triggered.
 * The function will be called after it stops being called for N milliseconds.
 * If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
 *
 * Reference: https://davidwalsh.name/javascript-debounce-function
 ********/

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/******
 * Mobile and Desktop  Menu Switch
 *
 * Desktop Menu: Second level menu dropdown
 * Mobile Menu: Second level menu slide to open
 ******/
var menuState = "";
var navigationBreakpoint = 1240;
var mobileDesktopMenuSwitch = debounce(function() {
  if(menuState !== "mobile" && window.innerWidth < navigationBreakpoint) {
    menuState = "mobile";
    jQuery('.hamburger-icon').on('click', function(e){
      e.preventDefault();
      jQuery(this).toggleClass('active');
      jQuery(this).parents('.mobile-menu').toggleClass('first-level-open');
      jQuery('.mobile-menu').removeClass('second-level-open');
      jQuery('.menu-item-has-children').removeClass('open');
      jQuery('html').toggleClass('no-scroll');
    });

    jQuery('.menu-item-has-children > a').click(function(e){
      e.preventDefault();
      jQuery(this).parents('.mobile-menu').toggleClass('second-level-open');
      jQuery(this).parent().toggleClass('open');
    });

    jQuery('.menu-item-has-children > a').one('click', function(e){
      //This code onle need to run once
      jQuery(this).siblings('.second-level-menu').find('.second-level-parent').append(jQuery(this).clone());
    });

    jQuery('.mobile-menu .back-to-main').click(function(e) {
      jQuery('.mobile-menu').removeClass('second-level-open');
      jQuery('.menu-item-has-children').removeClass('open');
    });
  } else if(window.innerWidth >= navigationBreakpoint) {
    menuState = "desktop";
    jQuery('.hamburger-icon').off('click');
    jQuery('.menu-item-has-children > a').off('click');
    jQuery('.menu-item-has-children > a').off('click');
    jQuery('.second-level-menu .back').off('click');
  }
}, 250);

mobileDesktopMenuSwitch(); //run one on load
window.addEventListener('resize', mobileDesktopMenuSwitch);


function initLightbox(parentClass) {
  if(typeof parentClass === 'undefined' || !parentClass) return; //early return if parentClass is undefined

  jQuery(parentClass+'__image, '+parentClass+'__more').on('click', function(){
    var index = jQuery(this).data('index');
    var lightbox = jQuery(this).parents(parentClass).find(parentClass+'__lightbox');
    lightbox.addClass('active');
    setTimeout(function() { //strangely needs timeout to works
      lightbox.find('.lightbox').slick('slickGoTo', index, true);
    }, 10);

    jQuery('html').css('overflow-y', 'hidden');
    jQuery('body').css('overflow-y', 'hidden');
  });

  jQuery(parentClass+'__lightbox--close').on('click', function(){
    jQuery(this).parent().removeClass('active');

    jQuery('html').css('overflow-y', 'auto');
    jQuery('body').css('overflow-y', 'auto');
  });

  //Main Slider
  jQuery(parentClass+'__lightbox .lightbox').slick({
    slidesToShow: 1,
    infinite: false,
    dots: false,
    lazyLoad: 'ondemand',
    arrows: true,
    prevArrow: "<img src='/content/themes/DailyPress/assets/images/arrow-left.svg' class='slick-prev' />",
    nextArrow: "<img src='/content/themes/DailyPress/assets/images/arrow-right.svg' class='slick-next' />",
    asNavFor: parentClass+'__lightbox .lightbox-navigation',
  });

  //Navigation Slider
  jQuery(parentClass+'__lightbox .lightbox-navigation').slick({
    slidesToShow: 4,
    infinite: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: true,
    swipeToSlide: true,
    prevArrow: "<img src='/content/themes/DailyPress/assets/images/arrow-left.svg' class='slick-prev' />",
    nextArrow: "<img src='/content/themes/DailyPress/assets/images/arrow-right.svg' class='slick-next' />",
    asNavFor: parentClass+'__lightbox .lightbox',
    responsive: [
      {
        breakpoint: 680,
        settings: {
            slidesToShow: 3,
        }
      }
    ]
  });
}
initLightbox('.function_gallery');